import { render, staticRenderFns } from "./FeedbacksTitle.vue?vue&type=template&id=08638c2e&scoped=true"
import script from "./FeedbacksTitle.vue?vue&type=script&lang=js"
export * from "./FeedbacksTitle.vue?vue&type=script&lang=js"
import style0 from "./FeedbacksTitle.vue?vue&type=style&index=0&id=08638c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08638c2e",
  null
  
)

export default component.exports